;(() => {
  const descriptionText = document.querySelector(
    'header.section-header .description'
  )

  function isTextOverflowing(element) {
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight)
    const maxHeight = parseFloat(getComputedStyle(element).maxHeight)
    const maxLines = Math.floor(maxHeight / lineHeight)
    const totalLines = Math.floor(element.scrollHeight / lineHeight)
    return totalLines > maxLines
  }

  if (descriptionText && isTextOverflowing(descriptionText)) {
    const readMoreButton =
      descriptionText.parentElement.querySelector('button.read-more')
    descriptionText.parentElement
      .querySelector('button.read-more')
      .classList.add('active')

    readMoreButton.addEventListener('click', function () {
      descriptionText.classList.add('expand')
      readMoreButton.classList.remove('active')
    })
  }
})()
